/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Revenue_Box_InfoInputs */

const en_admin_dashboard_revenue_box_info = /** @type {(inputs: Admin_Dashboard_Revenue_Box_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total revenue shows your net revenue from all sales over the last 30 days.`)
};

const nl_admin_dashboard_revenue_box_info = /** @type {(inputs: Admin_Dashboard_Revenue_Box_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale omzet toont je netto-omzet uit alle verkopen over de laatste 30 dagen.`)
};

/** @type {(inputs: Admin_Dashboard_Revenue_Box_InfoInputs) => LocalizedString} */
const de_admin_dashboard_revenue_box_info = en_admin_dashboard_revenue_box_info;

/** @type {(inputs: Admin_Dashboard_Revenue_Box_InfoInputs) => LocalizedString} */
const es_admin_dashboard_revenue_box_info = en_admin_dashboard_revenue_box_info;

/** @type {(inputs: Admin_Dashboard_Revenue_Box_InfoInputs) => LocalizedString} */
const fr_admin_dashboard_revenue_box_info = en_admin_dashboard_revenue_box_info;

/** @type {(inputs: Admin_Dashboard_Revenue_Box_InfoInputs) => LocalizedString} */
const it_admin_dashboard_revenue_box_info = en_admin_dashboard_revenue_box_info;

/** @type {(inputs: Admin_Dashboard_Revenue_Box_InfoInputs) => LocalizedString} */
const pt_br2_admin_dashboard_revenue_box_info = en_admin_dashboard_revenue_box_info;

/** @type {(inputs: Admin_Dashboard_Revenue_Box_InfoInputs) => LocalizedString} */
const pl_admin_dashboard_revenue_box_info = en_admin_dashboard_revenue_box_info;

/** @type {(inputs: Admin_Dashboard_Revenue_Box_InfoInputs) => LocalizedString} */
const hu_admin_dashboard_revenue_box_info = en_admin_dashboard_revenue_box_info;

/** @type {(inputs: Admin_Dashboard_Revenue_Box_InfoInputs) => LocalizedString} */
const ro_admin_dashboard_revenue_box_info = en_admin_dashboard_revenue_box_info;

/**
* | output |
* | --- |
* | "Total revenue shows your net revenue from all sales over the last 30 days." |
*
* @param {Admin_Dashboard_Revenue_Box_InfoInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_revenue_box_info = /** @type {((inputs?: Admin_Dashboard_Revenue_Box_InfoInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Revenue_Box_InfoInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_revenue_box_info(inputs)
	if (locale === "de") return de_admin_dashboard_revenue_box_info(inputs)
	if (locale === "es") return es_admin_dashboard_revenue_box_info(inputs)
	if (locale === "fr") return fr_admin_dashboard_revenue_box_info(inputs)
	if (locale === "nl") return nl_admin_dashboard_revenue_box_info(inputs)
	if (locale === "it") return it_admin_dashboard_revenue_box_info(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_revenue_box_info(inputs)
	if (locale === "pl") return pl_admin_dashboard_revenue_box_info(inputs)
	if (locale === "hu") return hu_admin_dashboard_revenue_box_info(inputs)
	return ro_admin_dashboard_revenue_box_info(inputs)
});
export { admin_dashboard_revenue_box_info as "admin.dashboard.revenue_box_info" }